<template>
  <div>
    <div>
      <Drawer
        :title="current_item.name + '的简历详情'"
        :closable="true"
        v-model="show"
        width="600px"
      >
        <div class="page_main">
          <div class="field_item">
            <div class="item_field">简历ID：</div>
            <div class="item_value">{{ current_item.resume_id }}</div>
          </div>

          <div v-for="(item, i) in detail_list" :key="i" class="field_item">
            <div class="item_field">{{ item.label }}：</div>
            <div class="item_value" v-if="item.field_type == 'txt'">{{ item.value }}</div>
            <div class="item_value" v-if="item.field_type == 'png'">
              <Image
                :src="item.value"
                fit="contain"
                width="120px"
                height="80px"
                preview
                :preview-list="[item.value]"
                initial-index="0"
              />
            </div>
          </div>
        </div>
        <div class="drawer_options">
          <span class="dangan_span" @click="click_dangan()">
            <Icon size="18" type="md-filing" />

            员工档案({{ file_count }})
          </span>

          <span class="dangan_span" @click="click_cert()">
            <span class="iconfont iconzizhizhengshu"></span>
            技能证书({{ cert_count }})
          </span>
          <span class="dangan_span" @click="click_bankcard()">
            <Icon type="ios-card" size="18" />
            银行卡({{ bankcard_count }})
          </span>
          <span class="dangan_span" @click="click_faxin_weituo()">
            <Icon type="logo-sass" size="18" />
            发薪委托书({{ weituoshu_count }})
          </span>
        </div>
      </Drawer>
    </div>
    <staff_cert ref="staff_cert"></staff_cert>
    <staff_bankcard ref="staff_bankcard"></staff_bankcard>
    <staff_faxin_weituo ref="staff_faxin_weituo"></staff_faxin_weituo>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import staff_cert from "./staff_cert.vue";
import staff_bankcard from "./staff_bankcard.vue";
import staff_faxin_weituo from "./staff_faxin_weituo.vue";

export default {
  components: { staff_cert, staff_bankcard, staff_faxin_weituo },
  name: "resume_detail",
  props: [],
  data() {
    return {
      show: false,
      current_item: {},
      detail_list: [],
      file_count: 0,
      cert_count: 0,
      bankcard_count: 0,
      weituoshu_count:0
    };
  },
  defineExpose: {},
  mounted() {},
  methods: {
    click_bankcard() {
      this.$refs.staff_bankcard.open(this.current_item.resume_id);
    },
    click_faxin_weituo() {
      this.$refs.staff_faxin_weituo.open(this.current_item.resume_id,this.project_id);
    },

    click_cert() {
      this.$refs.staff_cert.open(this.current_item.resume_id);
    },

    click_dangan() {
      console.log(this.current_item);
      open_new_page(
        "/staff_file?resume_id=" +
          this.current_item.resume_id +
          "&project_id=" +
          this.project_id
      );
    },

    //获取简历详情
    get_resume_detail() {
      var that = this;
      var obj = {
        resume_id: this.current_item.resume_id,
        project_id:this.project_id
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/resume_detail",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.detail_list = res.data.resume_detail;
            that.file_count = res.data.file_count;
            that.cert_count = res.data.cert_count;
            that.bankcard_count = res.data.bankcard_count;
            that.weituoshu_count = res.data.weituoshu_count
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    open(current_item, project_id) {
      this.project_id = project_id;
      this.current_item = current_item;
      this.show = true;
      this.get_resume_detail();
    },
  },
};
</script>

<style scoped>
.page_main {
  height: calc(100vh - 130px);
  overflow: auto;
}

.dangan_span:hover {
  background: #045ccf;
}

.dangan_span {
  background: #0466dd;
  margin-right: 10px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 50px;
}

.drawer_options {
  padding-top: 10px;
  border-top: 1px solid #ccc;
  position: fi;
  bottom: 0px;
  width: calc(100% - 30px);
  display: flex;
  align-items: center;
}

.item_field {
  color: #333;
  font-size: 13px;
  width: 110px;
}

.item_value {
  font-size: 13px;
  color: #888;
}

.field_item {
  overflow: auto;
  display: flex;
  align-items: center;

  margin-bottom: 10px;
}
</style>
